import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export function NoInternetError() {
    const modalTitle = <Typography>Kein Internet!</Typography>;
    const modalContent = (
        <ContentTypography>
            Überprüfe bitte deine Internetverbindung.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
